export default __webpack_public_path__ + "static/flow-bg-569e6c894e2d8ae748006aa9539a2a31.png";